import React, { Component } from 'react';

class ProjectIframe extends Component {

    render() {
        return (
            <div className="iframe-content">
                <iframe style={{ border: 'none' }} width={'100%'} src={this.props.src} />
            </div>
        )
    }
}

export default ProjectIframe;
